import {useEffect, useContext} from 'react';

import {ContentDiscoveryContext} from 'client/components/ContentDiscovery/ContentDiscoveryContext';

import {useContentDiscoveryStore} from '../ContentDiscoveryStore.react';
import {pages} from '../slices/Navigation.store';

export const useNavigationSubscription = () => {
  const {questionsQuery, setQuestionsQuery} = useContext(ContentDiscoveryContext);

  const currentPage = useContentDiscoveryStore((state) => state.navigation.currentPage);
  const assignment = useContentDiscoveryStore((state) => state.assignment.assignment);

  useEffect(() => {
    const {draft} = useContentDiscoveryStore.getState();

    const unsubscribers = [
      useContentDiscoveryStore.subscribe(
        (state) => state.navigation.initialName,
        (initialName) => {
          draft.setDraftName(initialName);
        }
      )
    ];

    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);

  useEffect(() => {
    const {handleHashChange} = useContentDiscoveryStore.getState().navigation;

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (currentPage !== pages.review) {
      // this is to reinitiate the questions query when we switch from the review to add page
      // However, because `questionsQuery` is being set to itself,
      // it seems to rely on broken behavior where `questionsQuery` is expected to be non-null
      // but is actually null within the `useContentDiscoveryStore.subscribe` callback
      // this can be revisted when we migrate question state into zustand
      setQuestionsQuery(questionsQuery);
    }
  }, [currentPage, assignment]);
};
